import {
  type DialogComponentProps,
  type GLOBAL_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import * as styles from './index.css';
import { useI18n } from '@affine/i18n';
import IconFont from '@ys/repo-ui/base/IconFont';
import { useService } from '@toeverything/infra';
import { GlobalContextService } from '@affine/core/modules/global-context';

import { CheckoutSlot } from '../../components/checkout-slot-new';
import { generateSubscriptionCallbackLink } from '@affine/core/components/hooks/affine/use-subscription-notify';
import { AuthService } from '@affine/core/modules/cloud';
import { Button } from '@affine/component';
import { Modal } from '@affine/component/ui/modal';

export const AddonDialog = ({
  close,
  prices,
  remaindCredits,
}: DialogComponentProps<GLOBAL_DIALOG_SCHEMA['add-on']>) => {
  const t = useI18n();
  const authService = useService(AuthService);

  return (
    <Modal
      width={1280}
      height={414}
      contentOptions={{
        ['data-testid' as string]: 'setting-modal',
        style: {
          maxHeight: '85vh',
          maxWidth: 'calc(100dvw - 100px)',
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
        },
        className: styles.addon_content,
      }}
      open
      onOpenChange={() => close()}
      withoutCloseButton={true}
    >
      <>
        <div
          className={`${styles.addon_content_close}`}
          onClick={() => close()}
        >
          <img
            className={styles.addon_content_close_icon}
            src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/closeModalIcon.png"
            alt=""
          />
        </div>
        <div className={styles.addon_content_top}>
          <img
            src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/addonTitleImageNew.jpg"
            className={styles.addon_content_top_image}
          />
          <div className={styles.addon_content_top_title}>
            {t['com.muset.payment.add-on.modal.title']()}
          </div>
          <div className={styles.addon_content_top_desc}>
            {t['com.muset.payment.add-on.modal.description']()}
          </div>
          <div className={styles.addon_content_top_credits}>
            <IconFont
              name="four-star"
              size={24}
              className={styles.addon_content_top_credits_icon}
            />
            <span className={styles.addon_content_top_credits_text}>
              {t['com.muset.payment.add-on.modal.credits']()}
            </span>
            <span className={styles.addon_content_top_credits_amount}>
              {remaindCredits}
            </span>
          </div>
        </div>
        <div className={styles.addon_content_price_list}>
          {prices.map(price => {
            return (
              <div className={styles.addon_content_price}>
                <div className={styles.addon_content_price_credit}>
                  <IconFont
                    name="four-star"
                    size={24}
                    className={styles.addon_content_price_icon}
                  />
                  <div className={styles.addon_content_tprice_credit_value}>
                    {price.quantity}
                  </div>
                  {price.giftQuantity !== 0 && (
                    <div className={styles.addon_content_price_credit_tag}>
                      +
                      {t['com.muset.payment.add-on.modal.credits.tag']({
                        amount: price.giftQuantity.toString(),
                      })}
                    </div>
                  )}
                </div>
                <CheckoutSlot
                  checkoutOptions={{
                    productId: price.id,
                    price: price.sellingPrice.toString(),
                    successCallbackLink: generateSubscriptionCallbackLink(
                      authService.session.account$.value,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      'true'
                    ),
                  }}
                  renderer={({ onClick, loading }) => {
                    return (
                      <Button
                        className={styles.addon_content_price_button}
                        variant={'primary'}
                        onClick={onClick}
                        disabled={loading}
                      >
                        {price.pricingCurrency}
                        {price.sellingPrice}
                      </Button>
                    );
                  }}
                />
              </div>
            );
          })}
        </div>
      </>
    </Modal>
  );
};
